import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { usePageSeo } from "@/hooks/usePageSeo";
import { getHotVideos } from "@/lib/videos";

export default function NotFound() {
  const location = useLocation();

  usePageSeo({
    title: "激情视频 - 页面未找到",
    description: "你访问的页面不存在，可以返回激情视频首页继续浏览精选激情影视与短视频内容。",
  });

  const suggestions = getHotVideos(3);

  return (
    <SiteLayout>
      <div className="px-4 md:px-8 lg:px-12 py-16 md:py-24">
        <div className="max-w-3xl mx-auto text-center">
          <p className="font-heading text-7xl md:text-9xl font-bold leading-none text-background-300 select-none">
            404
          </p>
          <h1 className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-50">页面不存在</h1>
          <p className="mt-3 text-sm text-foreground-500">
            你访问的地址 <span className="text-foreground-300">{location.pathname}</span> 没有对应内容，可能链接已失效。
          </p>
          <div className="mt-6 flex items-center justify-center gap-2 flex-wrap">
            <Link
              to="/"
              className="h-10 px-5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1.5"
            >
              <i className="ri-home-5-line" />
              返回首页
            </Link>
            <Link
              to="/search"
              className="h-10 px-5 rounded-md border border-background-300/70 text-sm text-foreground-200 hover:border-primary-400 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1.5"
            >
              <i className="ri-search-line" />
              全站搜索
            </Link>
          </div>

          <div className="mt-12 text-left">
            <h2 className="text-sm font-medium text-foreground-200 mb-3">热门作品推荐</h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {suggestions.map((video) => (
                <Link
                  key={video.id}
                  to={`/detail/${video.id}`}
                  className="flex items-center gap-3 p-2.5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-500/60 transition-colors cursor-pointer"
                >
                  <span className="w-11 h-14 rounded-md overflow-hidden shrink-0 bg-background-300">
                    <img
                      src={video.cover}
                      alt={`${video.title} 封面`}
                      title={`${video.title} 热门推荐`}
                      className="w-full h-full object-cover object-top"
                    />
                  </span>
                  <span className="min-w-0">
                    <span className="block text-xs text-foreground-100 truncate">{video.title}</span>
                    <span className="block mt-1 text-[11px] text-foreground-500 truncate">
                      {video.category} · {video.year}
                    </span>
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}